import declare from "dojo/_base/declare";
import { PreferenceView } from "csi/prefs/PreferenceView";
import sessionConstants from "csi/sessionConstants";
import Widget from "csi/table/Widget";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import { QueryLevel } from "csi/view/_query/Level";

const PRODUCT_TYPE = "ProductType";

const ProjectLineItemsTable = declare(Widget, {
	/**
	 * @override
	 * Project Items Table View to Group by ProductType
	 */
	onCreateDefaultCustomView(cv: PreferenceView): void {
		this.inherited(arguments);
		this.setDefaultGroupAndExpand(PRODUCT_TYPE);
	},

	/**
	 * @override
	 * Display Project Items for the supplier user
	 */
	onCreateMainQueryLevel(ql: QueryLevel): void {
		ql.serverQuery = new Query().Node(xml.PROP_URL, xml.OP_EQUALS, sessionConstants.userSupplierUrl, "Child:AssignedSuppliers");
	},
});

export = ProjectLineItemsTable;